/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SET_MY_SHOWS_USER_SETTINGS_FOCUSED_OPTION_INDEX =
    'SET_MY_SHOWS_USER_SETTINGS_FOCUSED_OPTION_INDEX';
export const SET_MY_SHOWS_USER_SETTINGS_OPTIONS = 'SET_MY_SHOWS_SETTINGS_OPTIONS';
export const SET_MY_SHOWS_USER_SETTINGS_VALUE = 'SET_MY_SHOWS_USER_SETTINGS_VALUE';
export const SET_MY_SHOWS_USER_SETTINGS_ERROR = 'SET_MY_SHOWS_USER_SETTINGS_ERROR';
